import { Link } from "@tanstack/react-router";
import { Linkedin, Mail, MapPin, BadgeCheck } from "lucide-react";
import { SITE } from "@/content/site";
import portrait from "@/assets/tamal-portrait-photo.webp?w=192&format=webp";

/**
 * E-E-A-T author box for article-style pages.
 * Surfaces experience, expertise, location, and verifiable profiles
 * — both for human readers and answer-engine crawlers.
 */
export function AuthorBox() {
  return (
    <aside className="mt-16 rounded-3xl border border-border bg-card p-8 lg:p-10">
      <div className="flex flex-col sm:flex-row gap-6 sm:items-start">
        <img
          src={portrait}
          alt={`${SITE.fullName}, senior SEO expert in ${SITE.city}, ${SITE.country}`}
          width={96}
          height={96}
          loading="lazy"
          decoding="async"
          className="size-24 rounded-2xl object-cover shrink-0"
        />
        <div className="flex-1">
          <div className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-primary">
            <BadgeCheck size={14} /> Written by
          </div>
          <h3 className="mt-2 font-display text-2xl">
            <Link to="/about" className="hover:text-primary">{SITE.fullName}</Link>
          </h3>
          <p className="mt-1 text-sm text-muted-foreground">
            SEO, AEO and GEO consultant based in Rangpur · technical SEO, local SEO, ecommerce SEO,
            and AEO/GEO for AI search. Working with brands across Bangladesh and worldwide.
          </p>
          <ul className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-muted-foreground">
            <li className="inline-flex items-center gap-1.5"><MapPin size={12} /> {SITE.city}, {SITE.country}</li>
            <li><a href={SITE.social.linkedin} rel="author me" className="inline-flex items-center gap-1.5 hover:text-primary"><Linkedin size={12} /> LinkedIn</a></li>
            <li><a href={`mailto:${SITE.email}`} className="inline-flex items-center gap-1.5 hover:text-primary"><Mail size={12} /> {SITE.email}</a></li>
          </ul>
        </div>
      </div>
    </aside>
  );
}